import { makeStyles, Tab, Tabs } from "@material-ui/core";
import { Collection, Linked } from "@type-r/models";
import * as React from "react";
import { ExpiredQuote, OrderCount, localUserInfo } from "api";
import { categories, CategoryTab } from "./common";

export interface OrdersHeaderProps {
  $category: Linked<CategoryTab>;
  orderCounts: Collection<OrderCount>;
  expiredQuotes: Collection<ExpiredQuote>;
}

export const OrdersHeader = ({
  $category,
  orderCounts,
  expiredQuotes
}: OrdersHeaderProps) => {
  const classes = useStyles();

  // Calculate number of items in each category.
  const pending = orderCounts.models.reduce(
    (acc, v) => acc + v.category_count("pending"),
    0
  );
  const active = orderCounts.models.reduce(
    (acc, v) => acc + v.category_count("active"),
    0
  );
  const invoiced = orderCounts.models.reduce(
    (acc, v) => acc + v.category_count("invoiced"),
    0
  );
  const inactive = orderCounts.models.reduce(
    (acc, v) => acc + v.category_count("inactive"),
    0
  );

  const categoryCount = {
    pending,
    active,
    invoiced,
    inactive,
    all: pending + active + invoiced + inactive
  };

  return (
    <div className={classes.root}>
      <Tabs value={$category.value} onChange={(_, x) => $category.set(x)}>
        {categories.map(category =>
          category !== "separator" ? (
            category !== "expired" ||
            localUserInfo.isSupplier ||
            localUserInfo.isAdminRead ? (
              <Tab
                value={category}
                key={category}
                classes={{
                  root: classes.tab,
                  selected: classes.selected
                }}
                disabled={
                  category !== "expired"
                    ? !categoryCount[category]
                    : !expiredQuotes.length
                }
                label={
                  <CategoryTab
                    key={category}
                    category={category}
                    count={
                      category !== "expired"
                        ? categoryCount[category] || 0
                        : expiredQuotes.length
                    }
                  />
                }
              />
            ) : (
              undefined
            )
          ) : (
            <Tab
              key="disabled"
              value={category}
              disabled
              classes={{
                root: classes.separator
              }}
              label={<span className={classes.separatorElement} />}
            />
          )
        )}
      </Tabs>
    </div>
  );
};

const CategoryTab = ({ category, count }) => {
  const classes = useStyles();

  return (
    <div className={classes.orderTab}>
      <div className={classes.number}>{count.toLocaleString()}</div>
      <div className={classes.title}>{category} </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: "#052C4C",
    color: "white",
    paddingBottom: 10
  },

  orderTab: {
    fontFamily: "Montserrat",
    paddingBottom: 2,
    textAlign: "left"
  },

  separator: {
    width: 35,
    minWidth: 20
  },

  separatorElement: {
    borderLeft: "solid",
    borderWidth: 1,
    borderColor: "white",
    height: 41,
    marginTop: 7
  },

  number: {
    fontSize: 28,
    fontWeight: 300
  },

  title: {
    fontSize: 12,
    fontWeight: 600,
    marginTop: -8,
    textTransform: "uppercase"
  },

  tab: {
    minWidth: 80, // a number of your choice

    "&:hover": {
      color: "#FFF",
      opacity: 1
    },

    "&:focus": {
      color: "#FFF",
      opacity: 1
    },

    "&$selected": {
      color: "#FFF",
      opacity: 1
    }
  },

  selected: {}
});
